export function workspaceCapabilities(participant) {
  if (!participant) return { canEdit: true, canStartRound: false, canFollowup: false, canViewScore: true, canUseLegacyAI: true }
  const writing = participant.stage === 'writing' && participant.status === 'open'
  return { canEdit: writing, canStartRound: writing, canFollowup: writing, canViewScore: participant.stage === 'complete', canUseLegacyAI: false }
}
export function experimentDraft(store) {
  return JSON.parse(JSON.stringify({ research_topic: store.researchTopic, cefr_level: store.cefrLevel, draft_sections: store.draftSections, references: store.references }))
}
